import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'tiFAIconClass',
})
export class FAIconClassPipe implements PipeTransform {
  transform(iconName: any, ...args: string[]): string {
    return 'fa fa-' + iconName;
  }
}
